import { Component, Inject, EventEmitter, Output, OnInit } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { User } from '@cigna/chcp/working-with-cigna/manage-access-feature';

import {
  DashboardFacade,
  LOADING_STATE,
} from '@cigna/chcp/dashboard/data-access';
import {
  DashboardWamUserDetailGQLService,
  DashboardWamUserDetailQueryGQL,
} from '@cigna/chcp/shared/graphql-util';
import { FeatureTogglesFacade } from '@cigna/features';
import { map, startWith, take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { GraphQLError } from 'graphql';

@Component({
  selector: 'cigna-manage-access-view-user-dialog',
  templateUrl: './manage-access-view-user-dialog.component.html',
  styleUrls: ['./manage-access-view-user-dialog.component.scss'],
})
export class ManageAccessViewUserDialogComponent implements OnInit {
  gqlDashboardEnabled$ = this.featureToggleFacade.featuresEnabled([
    'gqlDashboard',
  ]);

  wamUserGql$: Observable<{
    loading: boolean;
    data: {
      wamDashboardUsers: DashboardWamUserDetailQueryGQL['wamDashboardUsers'];
    };
    errors: readonly GraphQLError[] | null | undefined;
  }>;

  viewingUser$ = this.dashboardFacade.manageAccessViewingUser$;
  viewAccessView$ = this.dashboardFacade.manageAccessViewingUserState$;

  constructor(
    public dialogRef: MatDialogRef<ManageAccessViewUserDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      user: User;
      impersonator: boolean;
    },
    private dashboardFacade: DashboardFacade,
    private wamUserDetailGql: DashboardWamUserDetailGQLService,
    private featureToggleFacade: FeatureTogglesFacade,
  ) {}

  @Output() editIndividualUser = new EventEmitter();

  LOADING_STATE = LOADING_STATE;

  ngOnInit() {
    this.gqlDashboardEnabled$.pipe(take(1)).subscribe((enabled) => {
      if (enabled) {
        this.wamUserGql$ = this.wamUserDetailGql
          .watch({
            input: {
              users: [this.data.user.id],
            },
          })
          .valueChanges.pipe(
            startWith({
              loading: true,
              data: {
                wamDashboardUsers: [],
              },
              errors: null,
            }),
            map((result) => ({
              loading: result.loading,
              data: {
                wamDashboardUsers: result.data.wamDashboardUsers,
              },
              errors: result.errors,
            })),
          );
      } else {
        this.dashboardFacade.getManageAccessUserDetail(this.data.user);
      }
    });
  }

  onEdit(): void {
    this.editIndividualUser.emit();
  }
  onClose(): void {
    this.dialogRef.close();
  }
}
